module.exports = __webpack_public_path__ + "img/egg2.ec8f1597.png";